// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3grA2","options":"AnswerScale_options__FeesK","selected":"AnswerScale_selected__1BfcR"};